import enumBase from '@/enums/EnumBase';

/*
 * In billing-api, App\Enum\ConsumptionsPeriodType, each value have a limit:
 * daily -> 10 days
 * weekly -> 12 weeks
 * biweekly -> 15 ( * 2 ) weeks (last 30 weeks)
 * monthly -> 12 months ( last 1 year )
 * */
export default class ConsumptionsPeriodType extends enumBase {
  static values = [
    { value: 'daily', label: 'daily' },
    { value: 'weekly', label: 'weekly' },
    { value: 'biweekly', label: 'biweekly' },
    { value: 'monthly', label: 'monthly' },
  ];

  static getByValue(value) {
    const item = this.values.find((i) => i.value === value);
    return item ? `pages.plan.consumptionPeriodType.${item.label}` : value;
  }
}
